import React, { useEffect, useState } from "react";
import axios from "axios";
import userStore from "../../zustand/store/userStore";
import AppHeader from "./AppHeader";

const Notification = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const { user } = userStore();
  const userRole = user?.role;

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        setLoading(true);
        let res;

        if (userRole === "admin") {
          res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/getAllAnnouncement?page=${page}&limit=5`
          );
        } else {
          res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/getRoleWise?role=${userRole}&page=${page}&limit=5`
          );
        }

        setAnnouncements(res.data.data);
        setTotalPages(res.data.totalPages);
      } catch (err) {
        console.error("Error fetching announcements:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, [userRole, page]);

  const handlePrev = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-gray-50 to-blue-100">
      <AppHeader
        title="📢 Notifications"
        content={
          userRole === "admin"
            ? "Here are all the announcements you have published."
            : "You’re viewing announcements relevant to your role."
        }
      />
      <div className="max-w-5xl mx-auto mt-10 px-4">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="w-16 h-16 border-4 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : announcements.length === 0 ? (
          <div className="text-center text-gray-500 py-16 bg-white/50 rounded-xl shadow-lg backdrop-blur-md">
            🚫 No announcements found.
          </div>
        ) : (
          <>
            <div className="grid gap-6">
              {announcements.map((announcement, index) => (
                <div
                  key={index}
                  className="bg-white/80 backdrop-blur-md rounded-2xl p-6 shadow-2xl transition-all hover:-translate-y-1 hover:shadow-blue-200 duration-300 border border-blue-100"
                >
                  <div className="flex justify-between items-center mb-3">
                    <h2 className="text-2xl font-semibold text-gray-800">
                      {announcement.title}
                    </h2>
                    <span className="text-sm text-gray-500">
                      {new Date(announcement.createdAt).toLocaleString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </div>
                  <hr className="my-2 border-gray-200" />
                  <p className="text-gray-700 leading-relaxed text-base">
                    {announcement.message}
                  </p>
                </div>
              ))}
            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-10 space-x-4">
              <button
                onClick={handlePrev}
                disabled={page === 1}
                className={`px-5 py-2 rounded-lg transition-all duration-300 font-semibold ${page === 1
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700 text-white"
                  }`}
              >
                ⬅ Previous
              </button>
              <span className="text-gray-600 font-medium text-lg">
                Page {page} of {totalPages}
              </span>
              <button
                onClick={handleNext}
                disabled={page === totalPages}
                className={`px-5 py-2 rounded-lg transition-all duration-300 font-semibold ${page === totalPages
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700 text-white"
                  }`}
              >
                Next ➡
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Notification;
